import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { Collection, CollectionTarget } from "@ciaopeople/cp-shatsu/DomHelper";
import { EventHandler } from "@ciaopeople/cp-shatsu/EventHandler";
import { SimpleEventHandler } from "@ciaopeople/cp-shatsu/EventHandler";
import { isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { flatten } from "@ciaopeople/cp-shatsu/Utils";
import { GroupableData } from "../../api/commondata/GroupableData.js";
import { RESTUserServices } from "../../api/RESTUserServices.js";
import { AttachAndStatusData, ElementWithAttachData, ParseAndAttachModule } from "./ParseAndAttachModule.js";
import { SdkHandledHTMLElement } from "./SdkHandledHTMLElement.js";

type Action = (evt: string, data?: any) => void;

export const FOLLOW_SLIDER_FOUND_EVT = "followSliderFound";

export type SliderData = any;
class SliderHTMLElement extends SdkHandledHTMLElement<SliderData> {
    

    private sliderData: SliderData;
    /**
     * slider has no status
     * @param s 
     * @returns 
     */
    public setStatus(s: SliderData): SdkHandledHTMLElement<SliderData> {
        this.sliderData = s;
        return this;
    }
    public getStatus(): SliderData {
        return this.sliderData;
    }


    public getSliderName(): string {
        return this.firstAttr("data-slider-name");
    }

}


class GroupableSliderName implements GroupableData {
    
    constructor(public readonly sliderName: string) {

    }

    getGroupName(): string {
        return this.sliderName;
    }
}

export interface SliderEventWithInvolvedDOM  {
    dom: HTMLElement[]
    slider_data: any
}


export function isSliderEventWithInvolvedDOM(obj: any): obj is SliderEventWithInvolvedDOM  {
    return isObject(obj) && hasOwnProperty(obj, "dom") && hasOwnProperty(obj, "slider_data");
}

export class SliderParseAndAttachModule extends ParseAndAttachModule<SliderData, GroupableSliderName> {


    private eh: EventHandler;


    constructor(private restServices: RESTUserServices) {
        super();
        this.eh = new SimpleEventHandler();
          
        
    }

    protected extractAndCreate(el: HTMLElement): ElementWithAttachData<SliderData, GroupableSliderName> {
        const parsed = new SliderHTMLElement(el);
        if(parsed.getSliderName() != "") {
            return {
                element: parsed,
                attachData: new GroupableSliderName(parsed.getSliderName())
            };
        }
        else return null;
    }


    public action(_el: ElementWithAttachData<SliderData, GroupableSliderName>): void {

    }

    protected afterAttach(newlyAttached: ElementWithAttachData<SliderData, GroupableSliderName>[]): Promise<void> {
        if(newlyAttached && newlyAttached.length > 0) {
            return Promise.all(newlyAttached.map(el => {
                return this.restServices.
                    getSlider(el.attachData.sliderName, window.location.href).then(resp => {
                        return {
                            response: resp.data,
                            attachedData: el.attachData
                        };
                    });
            })).then(results => {
                this.updatedElementStatuses(results.map(res => {
                    return {
                        attachData: res.attachedData,
                        status: res.response
                    };
                }));
            });
        }
        else return Promise.resolve();

        
    }

    public parseAndAttach(el: CollectionTarget | CollectionTarget[], _trigger?: never): Promise<void> {
        return super.parseAndAttach(el, null);
    }

    protected afterUpdate(s: AttachAndStatusData<SliderData, GroupableSliderName>, involvedElements: SdkHandledHTMLElement<SliderData>[]): void {
        
        this.triggerFollowSliderFound(         
            {
                dom: flatten(involvedElements.map(ie => ie.ig())),
                slider_data: s.status
            }
        );

    }

    private triggerFollowSliderFound(evt: SliderEventWithInvolvedDOM): void {
        this.trigger(FOLLOW_SLIDER_FOUND_EVT, evt);
    }

    public onFollowSliderFound(fun: (evt: SliderEventWithInvolvedDOM) => any): void {
        this.on(FOLLOW_SLIDER_FOUND_EVT, (evt, data) => {
            if(isSliderEventWithInvolvedDOM(data)) fun(data);
        });
    }

    on(eventName: string, callback: Action) {
        this.eh.on(eventName, callback);
    }
    off(act: Action);
    off(evt: string, act: Action);
    off(evtOrAct: string | Action, act?: Action);
    off(evtOrAct: string | Action, act?: Action): any {
        return this.eh.off(evtOrAct, act);    
    }
    trigger(eventName: string, data: any): void {
        this.eh.trigger(eventName, data);
    }
    one(eventName: string, callback: Action): void {
        this.eh.one(eventName, callback);
    }

}